export const tooltipClasses =
   "bg-surface rounded-md shadow-modal max-w-100 p-6 text-left";

export const tooltipTitleClasses =
   "text-xl font-semibold text-content font-['Open_Sans',serif] mb-2";

export const tooltipContentClasses = "text-body text-sm leading-relaxed";

export const tooltipFooterClasses =
   "flex items-center justify-between gap-4 mt-6";

export const tooltipProgressClasses = "text-body text-xs shrink-0";

export const tooltipActionsClasses = "flex items-center gap-2";

export const tooltipSkipClasses =
   "bg-transparent border-0 p-0 text-body text-xs underline hover:text-content";

export const tooltipHintClasses =
   "text-body text-xs mt-3 flex items-baseline justify-between gap-3";

export const tooltipSkipStopClasses =
   "bg-transparent border-0 p-0 text-body text-xs underline hover:text-content shrink-0";

export const refresherPromptClasses =
   "fixed bottom-6 right-6 z-tour bg-surface rounded-md shadow-modal max-w-90 p-5 text-left";

export const refresherPromptTitleClasses =
   "text-base font-semibold text-content font-['Open_Sans',serif] mb-1";

export const refresherPromptBodyClasses = "text-body text-sm leading-relaxed";

export const refresherPromptActionsClasses = "flex items-center justify-end gap-2 mt-4";
